import React, { useEffect, useState } from 'react';

import AppInstallRequiredModal, {
  AppInstallRequiredModalProps,
} from '@/components/common/modal/cuj/AppInstallRequiredModal';
import useModal from '@/hooks/useModal';
import { MODAL_TYPE } from '@/types/modal';

interface UseAppInstallRequireModalState extends AppInstallRequiredModalProps {
  isVisible: boolean;
}

const defaultState: UseAppInstallRequireModalState = {
  isVisible: false,
  title: '',
  body: '',
  installButtonText: '',
  closeButtonText: ',',
};
const useAppInstallRequiredModal = () => {
  const { showModal: _showModal, closeModal: _closeModal } = useModal();
  const [state, setState] = useState<UseAppInstallRequireModalState>(defaultState);

  const showModal = (props: AppInstallRequiredModalProps) => {
    setState({ isVisible: true, ...props });
  };

  const closeModal = () => {
    setState(defaultState);
  };

  useEffect(() => {
    if (state.isVisible) {
      _showModal({
        type: MODAL_TYPE.BASIC,
        props: {
          body: (
            <AppInstallRequiredModal
              title={state.title}
              body={state.body}
              installButtonText={state.installButtonText}
              closeButtonText={state.closeButtonText}
            />
          ),
        },
      });
    } else {
      _closeModal();
    }
  }, [state]);

  useEffect(() => {
    const close = () => {
      closeModal();
    };

    window.addEventListener('popstate', close);

    return () => {
      window.removeEventListener('popstate', close);
    };
  });

  return {
    showModal: showModal,
    closeModal: closeModal,
  };
};

export default useAppInstallRequiredModal;
